// STICKY HEADER

$(window).scroll(function(e) {
  	if($(window).width()>992) {
      if($(window).scrollTop()>145) {
        $('.nav-bar').addClass("stickyNav");
        $('.is-moved-by-drawer').removeClass("is-moved-by-drawer");
      } else {
        $('.nav-bar').removeClass("stickyNav");
        $('.is-moved-by-drawer').addClass("is-moved-by-drawer");
      }
    }
  });


// SITE SCROLLER
  $("#scroll-top").click(function() {
    $("html, body").animate({ scrollTop: 0 }, 1000);
    return false;
  });


// PROMOTION HEADER show-hide
  if(Cookies.get('promotion') != 'true') {   
     $(".promotion-header").show();         
  }
 
  $(".closeHeader").click(function() {
    $(".promotion-header").slideUp();  
    Cookies.set('promotion', 'true', { expires: 1});  
  });



$(document).ready(function(e) {    
  
  if($(window).width() < 767) {
  	$('.wow').removeClass('wow');
  }
  
  // NEWSLETTER load one time on site load
  if(Cookies.get('visited') != 'true') {   
    $("#newsletter-modal").show();
    $(".newsletter-wrap").show();      
    Cookies.set('visited', 'true', { expires: 1});    
  } 
  else {
    $("#newsletter-modal").hide();
    $(".newsletter-wrap").hide();
  }
  
  $(document).mouseup(function (e){
   	var container = $("#newsletter-modal");
    if (!container.is(e.target)
        && container.has(e.target).length === 0)
    	{
          container.hide();
          $(".newsletter-wrap").fadeOut();
    	}
	});
  
  $(".closepopup").click(function() {
    $("#newsletter-modal").fadeOut();
    $(".newsletter-wrap").fadeOut();
  });
  
  // CLOSE MODEL	
   $(".closeModal").click(function() {
    $(".quickshop").fadeOut();
  });
  
  //Footer links for mobiles
  $(".footer-links h3").click(function() {
    if($(window).width() < 767){
      $(this).toggleClass("active");
      $(this).next().slideToggle();
  	}
  });
   
  
  // SET MARGIN FOR SOLD OUT	
  marginSoldOut();
  setTimeout(marginSoldOut, 5000)
  $(window).resize(marginSoldOut);
  
  
  // SHOW HIDE PRODUCT TAG
  $(".product-tags 	li").eq(10).nextAll().hide(); 
  $('.btnview').click(function(){
    $(".product-tags li").not('.filter--active').show();
    $(this).hide();
  });
  
  
  // MOBILE CUSOTMER LINK  
  $('.mobile-customer-links .fa').click(function(){
    $(this).next().slideToggle();
   });      
   
  // TAB TO ACCORDIAN 
  $('.product-tabs .nav-tabs').tabCollapse();
  
  // CLOSE ADD TO CART MODAL
  $('.ajax-success-modal .btn--secondary').click(function(){   
	$('.ajax-success-modal').hide();
  });
  
  // HOME PAGE BLOG 
   jQuery(".blogs-grid").owlCarousel({
      dots: false,
      nav:true,
      responsive:{             
        0:{items:1},
      	479:{items:2}}
    });
  
  // BRAND CAROUSEL
  jQuery(".list-brand .owl-carousel").owlCarousel({
    dots:false,
    items:6,
    nav : true,
  	responsive:{      	    
        0:{items:1},
      	480:{items:2},
        768:{items:4},
        991:{items:5},
        1200:{items:6}
     }
  });
  
  // HOME FEATURED COLLECTION CAROUSEL
   jQuery(".list-featured-collection .collections-grid").owlCarousel({
      dots: false,
      nav:true,
      responsive:{
        0:{items:1},
        480:{items:2},
        767:{items:3},
        992:{items:4},
        1280:{items:5},
        1500:{items:4}
      }
    });  

   // HOME FEATURED PRODUCTS CAROUSEL
   jQuery(".list-featured-products .products-grid").owlCarousel({
      dots: false,
      nav:true,
      items : 5,
     responsive:{
        0:{items:1},       
        479:{items:2},
        768:{items:3},
        991:{items:4},
        1200:{items:5}
          }
    });   
  
   // HOME TRENDING PRODUCTS CAROUSEL
   jQuery(".list-trending-products .products-grid").owlCarousel({
      dots: false,
      nav:true,     
      responsive:{
        0:{items:1},       
        479:{items:2},
        768:{items:3},
        991:{items:4},
        1200:{items:5}
          }
    });
     
  // PRODUCT PAGE RELATED PRODUCTS CAROUSEL
   jQuery(".list-related-products .products-grid").owlCarousel({
      dots: false,
      nav:true,     
       responsive:{
        0:{items:1},       
        479:{items:2},
        768:{items:3},
        991:{items:4},
        1200:{items:5}
          }
    });
  
});

// SET MARGIN FOR SOLD OUT	
function marginSoldOut(){ 
  $('.products-grid .grid_item').each(function(){  
  		var sm =  $(this).find('.product_image').height()/2 - 10;
  	    $('.not-available').css("padding-top",sm);
  });
}

function productimagesize(){ 
  $('.products-grid .product_image').each(function(){
    	var pimgWidth = $(this).width();
    	if(pimgWidth < 270)
    		$(this).children("a").height(pimgWidth);
    	else {
          $(this).children("a").height(270);
        }
    	//alert(pimgWidth);
	});	
}

$(window).on('load resize', function () {
  productimagesize();
});

// WISHLIST SECTION
!function(e) {
    e(document).ready(function() {
      productimagesize();
        t.init()
    });
    var t = {
        nexGeekTimeOut: null,
        isSidebarAjaxClick: !1,
        init: function() {
            this.initModal(), 
            this.initWishlist(), 
            this.initProductWishlist(),
            this.initRemoveWishlist()
        },
        initWishlist: function() {
              $(".grid_item  .js-wish-list #contact_form").submit(function(e) {
              var pname= $(this).parents(".grid_item").find(".product_name a").text();              
              var a = $(this).parent();
              a.parents(".grid-item");
             var c = $(this).parents(".grid_item").find(".js-wish-list");
                    
              //e.preventDefault();
              var postData = $(this).serializeArray();
              var formURL = $(this).attr("action");
              $.ajax({
                url : formURL,
                type: "POST",
                data : postData,
                beforeSend: function() {
                  t.showLoading()
                },
               success: function() {
                 t.hideLoading(),
                   c.html('<a title="Already in your wishlist, Go to wishlist" href="/pages/wish-list" class="btn-action wishlist"><i aria-hidden="true" class="fa fa-heart"></i></a>');
                 $("#wishlist").fadeIn();       					    
                 $(".ajax-success-modal").find(".ajax-product-title").text(pname);

                 window.setTimeout(function(){$("#wishlist").fadeOut();}, 5000);                 
                 					
               },
               error: function(i) {
                 t.hideLoading(), e(".loading-modal").hide(), e(".ajax-error-message").text(e.parseJSON(i.responseText).description), t.showModal(".ajax-error-modal")
               }
              });
            });       
        },
        initProductWishlist: function() {
          
           $(".product-single .js-wish-list #contact_form").submit(function(e) {
              var pname= $(this).parents(".col-sm-6").find("h1").text();              
              var c = $(this).parents(".col-sm-6").find(".js-wish-list");
                    
              //e.preventDefault();
              var postData = $(this).serializeArray();
              var formURL = $(this).attr("action");
              $.ajax({
                url : formURL,
                type: "POST",
                data : postData,
                beforeSend: function() {
                  t.showLoading()
                },
               success: function() {
                 t.hideLoading(),
                   c.html('<a title="Already in your wishlist, Go to wishlist" href="/pages/wish-list" class="btn-action wishlist"><i aria-hidden="true" class="fa fa-heart"></i></a>');
                 $("#wishlist").fadeIn();       					    
                 $(".ajax-success-modal").find(".ajax-product-title").text(pname);
                 window.setTimeout(function(){$("#wishlist").fadeOut();}, 5000);                 
               },
               error: function(i) {
                 t.hideLoading(), e(".loading-modal").hide(), e(".ajax-error-message").text(e.parseJSON(i.responseText).description), t.showModal(".ajax-error-modal")
               }
              });
            });        
           
        },
        initRemoveWishlist: function() {
            e(".btn-remove-wishlist").click(function() {
                var i = e(this).parents("li"),
                    a = i.find(".tag-id").val(),
                    o = jQuery("#remove-wishlist-form");
                o.find("input[name='contact[tags]']").val("x" + a), e.ajax({
                    type: "POST",
                    url: "/contact",
                    data: o.serialize(),
                    beforeSend: function() {
                        t.showLoading()
                    },
                    success: function() {
                        //t.hideLoading(), i.fadeOut(1e3)
                        o.submit();
                    },
                    error: function(i) {
                        t.hideLoading(), e(".loading-modal").hide(), e(".ajax-error-message").text(e.parseJSON(i.responseText).description), t.showModal(".ajax-error-modal")
                    }
                })
            })
        },
        initModal: function() {
            e(".continue-shopping").click(function() {
                clearTimeout(t.nexGeekTimeOut), e(".ajax-success-modal").fadeOut(500)
            }), e(".close-modal, .overlay").click(function() {
                clearTimeout(t.nexGeekTimeOut), e(".ajax-success-modal").fadeOut(500)
            })
        },
        showLoading: function() {
            e(".loading-modal").show()
        },
        hideLoading: function() {
            e(".loading-modal").hide()
        }
    }
}(jQuery);

